import {get, post, download} from "../api"
import * as url from "../url"

const apiGetSimpleFilesFilter = data => {
  return get(url.API_SIMPLE_FILES + "filter/", data.history)
}

const apiPostSimpleFilesSegments = data => {
  return post(url.API_SIMPLE_FILES + "segments/", data.history, data.data)
}

const apiGetSimpleFilesList = data => {
  return post(url.API_SIMPLE_FILES + "list/", data.history, data.data)
}

const apiDownloadSimpleFilesDownload = data => {
  return download(url.API_SIMPLE_FILES + "download/" + data.sign, data.history, data.filename)
}

export {
  apiGetSimpleFilesFilter,
  apiPostSimpleFilesSegments,
  apiGetSimpleFilesList,
  apiDownloadSimpleFilesDownload,
}
